import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import { GrUpdate } from "react-icons/gr";
import axios from "axios";
// import "./userList.css";

function UserVehicleDetails() {
    const { id } = useParams();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showUpdatePaymentForm, setShowUpdatePaymentForm] = useState(false);
    const [payments, setPayments] = useState([]);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        userId: '',
        dueDate: '',
        paymentDate: '',
        amount: '',
        status: 'Paid',
    });
    const [updateData, setUpdateData] = useState({
        userId: '',
        dueDate: '',
        paymentDate: '',
        amount: '',
        status: 'Paid'
    });

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BASE_API_URL}/getUser/api/monthlyParkingUser/${id}`
                );

                console.log("Fetched user data:", response.data); // 👈 This will show you the full user object

                setUser(response.data);

                // Set userId correctly using response.data._id
                setFormData((prev) => ({
                    ...prev,
                    userId: response.data._id // ✅ This must be a valid ObjectId string
                }));
            } catch (err) {
                setError(err.response ? err.response.data.message : err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();


        const fetchPaymentHistory = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/payments/api/${id}/history`);
                setPayments(response.data.payments);
            } catch (err) {
                console.error("Failed to fetch payment history:", err);
            }
        };

        fetchPaymentHistory();
    }, [id]);
    //updating the data
    const handleUpdateChange = (e) => {
        const { id, value } = e.target;
        setUpdateData((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_API_URL}/payments/api/createMonthlyPayments`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            console.log('Payment submitted:', response.data);
            alert('Payment submitted successfully!');
        } catch (error) {
            console.error('Error submitting payment:', error);
            alert('Error submitting payment.');
        }
    };
    //function to handling update payment db
    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_API_URL}/payments/api/updateMonthlyPayments`,
                updateData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            console.log("Payment updated:", response.data);
            alert("Payment updated successfully!");
        } catch (error) {
            console.error("Error updating payment:", error);
            alert("Error updating payment.");
        }
    };

    const handleRequestClose = async (id) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_BASE_API_URL}/monthlyRentalParking/api/closeMonthlyParkingRequest/${id}`
            );

            toast.success(res.data.message || "Closure request submitted successfully!");
            console.log("Updated Entry:", res.data.data);
        } catch (err) {
            console.error("Error submitting closure request:", err);
            toast.error(err.response?.data?.message || "Failed to submit closure request");
        }
    };

    return (
        <div className="aboutMonthlyUser container mt-4 mb-4">
            <button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
                ⬅ Back
            </button>
            <h2>Monthly Rental User Details</h2>

            {loading && <p>Loading...</p>}
            {error && <p className="text-danger">Error: {error}</p>}

            {user && (
                <div className="userDetail row">
                    <div className="col-md-4 mb-3">
                        <div className="vehicleImage card p-3">
                            <img
                                src={`${process.env.REACT_APP_BASE_API_URL}/monthlyUploads/${user?.vehicleImage.split("\\").pop()}`}
                                alt="Vehicle"
                                className="img-fluid"
                            />
                        </div>
                    </div>

                    <div className="col-md-8">
                        <div className="userName card p-3">
                            <h4>Customer Name: {user.customerName.toUpperCase()}</h4>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card1 card p-3 text-center">
                                    <h5>Vehicle Number</h5>
                                    <p>{user.vehicleNumber.toUpperCase()}</p>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card2 card p-3 text-center">
                                    <h5>Vehicle Type</h5>
                                    <p>{user.vehicleType}</p>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card3 card p-3 text-center">
                                    <h5>Parking Slot</h5>
                                    <p>{user.parkingSlot}</p>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card4 card p-3 text-center">
                                    <h5>Rental Amount</h5>
                                    <p>Rs.{user.rentalAmount}/-</p>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card5 card p-3 text-center">
                                    <h5>Vehicle Entry Date</h5>
                                    <p>{new Date(user.createdAt).toLocaleDateString()}</p>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card6 card p-3 text-center">
                                    <h5>Customer Contact No</h5>
                                    <p>{user.contactNumber}</p>
                                    <h5>Customer Email Id</h5>
                                    <p>{user.email || "N/A"}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Payment Section */}
                    <div className="paymentDetails mt-4">
                        <h3>Rental Payment Details</h3>
                        {/* updating the payment */}
                        {showUpdatePaymentForm && (
                            <div className="card p-3 mb-3">
                                <h5>Update Payment</h5>
                                <form onSubmit={handleUpdate}>
                                    <div className="form-group text-start">
                                        <label htmlFor="userId">User ID</label>
                                        <input
                                            type="hidden"
                                            className="form-control"
                                            id="userId"
                                            value={updateData.userId}
                                            onChange={handleUpdateChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="dueDate">Due Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="dueDate"
                                            value={updateData.dueDate}
                                            onChange={handleUpdateChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="paymentDate">Payment Done Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="paymentDate"
                                            value={updateData.paymentDate}
                                            onChange={handleUpdateChange}
                                        />
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="amount">Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="amount"
                                            value={updateData.amount}
                                            onChange={handleUpdateChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="status">Status</label>
                                        <select
                                            className="form-control"
                                            id="status"
                                            value={updateData.status}
                                            onChange={handleUpdateChange}
                                        >
                                            <option value="Paid">Paid</option>
                                            <option value="Unpaid">Unpaid</option>
                                        </select>
                                    </div>

                                    <button type="submit" className="btn btn-warning mt-3" style={{ color: "#fff" }}>
                                        <GrUpdate style={{ height: "20px", width: "20px", marginBottom: "4px" }} /> Update Payment
                                    </button>
                                </form>
                            </div>
                        )}

                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>S.no</th>
                                    <th>Due Date</th>
                                    <th>Date of Payment</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {payments.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center">No payment history found.</td>
                                    </tr>
                                ) : (
                                    payments.map((payment, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{new Date(payment.dueDate).toLocaleDateString()}</td>
                                            <td>{payment.paymentDate ? new Date(payment.paymentDate).toLocaleDateString() : "—"}</td>
                                            <td>&#8377;{payment.amount}</td>
                                            <td className={payment.status === "Paid" ? "text-success" : "text-danger"}>
                                                {payment.status}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <div className="row mt-3">
                <div className="col-md-12 col-sm-6 mb-3">
                    <div className="card7 card p-3 text-center">
                        <h4>Request to Close the Rental Space</h4>
                        <p className="text-muted">
                            If you wish to terminate your monthly rental agreement for this vehicle, please submit a request below.
                        </p>
                        <button
                            className="btn btn-danger"
                            onClick={() => handleRequestClose(user._id)}
                        >
                            📩 Submit Closure Request
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserVehicleDetails;
